'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { ArrowRight, ChevronDown } from 'lucide-react';

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger
} from '@workspace/ui/components/dropdown-menu';

import {
  isProductNavigationActive,
  workflowHref,
  workflows
} from '~/lib/workflows';

export function ProductNavigation() {
  const pathname = usePathname();
  const active = isProductNavigationActive(pathname);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        data-active={active || undefined}
        className="marketing-nav-link flex min-h-10 items-center gap-1.5 rounded-sm text-sm font-medium"
      >
        Product
        <ChevronDown
          className="size-3.5"
          aria-hidden="true"
        />
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="start"
        sideOffset={14}
        className="w-[520px] max-w-[calc(100vw-32px)] rounded-xl p-3"
      >
        <DropdownMenuLabel className="px-3 pb-3 text-xs font-normal text-muted-foreground">
          Two workflows. One view of your accounts.
        </DropdownMenuLabel>
        <div className="grid gap-1">
          {workflows.map((item, index) => (
            <DropdownMenuItem
              key={item.slug}
              asChild
              className="marketing-nav-item items-start rounded-lg p-3"
            >
              <Link
                href={workflowHref(item)}
                aria-current={
                  pathname === workflowHref(item) ? 'page' : undefined
                }
                className="flex gap-3"
              >
                <span className="marketing-nav-number pt-0.5 font-mono text-[10px]">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <span>
                  <span className="block text-[13px] font-medium">
                    {item.title}
                  </span>
                  <span className="marketing-nav-description mt-1 block text-xs leading-relaxed text-muted-foreground">
                    {item.navigationDescription}
                  </span>
                </span>
              </Link>
            </DropdownMenuItem>
          ))}
        </div>
        <DropdownMenuSeparator className="my-2" />
        <DropdownMenuItem
          asChild
          className="marketing-nav-item rounded-lg px-3 py-2.5"
        >
          <Link
            href="/product#intelligence-explorer"
            className="flex justify-between text-xs"
          >
            Explore all capabilities
            <ArrowRight
              className="size-3.5"
              aria-hidden="true"
            />
          </Link>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
